/**
 * AddressParseFailedTag — visible error state for an unparseable address
 * (board2-#79 / #101 BE-03).
 *
 * When a stored address row carries parseStatus 'failed' (non-empty input the
 * backend parse could not resolve into stateId/cityId), the surfaces that
 * render structured state/city show this small warning Tag NEXT TO the raw
 * address instead of a silent pending+dash. 'pending' (not yet parsed / empty
 * input) intentionally renders nothing — only 'failed' is an error.
 *
 * Uses the antd semantic "warning" Tag preset (theme-token driven — no
 * hardcoded colors) and the common-namespace location.parseFailed copy
 * (en "Address could not be parsed" / zh 「地址無法解析」).
 */

import type { CSSProperties } from 'react';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

export interface AddressParseFailedTagProps {
  /** Extra inline style merged onto the Tag (spacing tweaks only) */
  style?: CSSProperties;
}

export function AddressParseFailedTag({ style }: AddressParseFailedTagProps) {
  const { t } = useTranslation('common');
  return (
    <Tag color="warning" style={{ marginInlineStart: 8, ...style }}>
      {t('location.parseFailed')}
    </Tag>
  );
}

export default AddressParseFailedTag;
